import { render, staticRenderFns } from "./MarkerDocumentType.vue?vue&type=template&id=987d9c90"
import script from "./MarkerDocumentType.vue?vue&type=script&lang=js"
export * from "./MarkerDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports